<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          v-if="isTeam"
          :link="{
            name: 'Affiliates',
            icon: 'fas fa-user-cog text-primary',
            path: '/affiliates/admin'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isTeam"
          :link="{
            name: 'Credit Notes',
            icon: 'fas fa-file-invoice text-primary',
            path: '/affiliates/notes'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isEnrolled"
          :link="{
            name: 'Referrals',
            icon: 'fas fa-users text-primary',
            path: '/affiliates/home'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isEnrolled"
          :link="{
            name: 'Statistics',
            icon: 'fas fa-chart-pie text-primary',
            path: '/affiliates/statistics'
          }"
        >
        </sidebar-item>
      </template>

      <template slot="links-after">
        <hr class="my-3" />
        <h6 class="navbar-heading p-0 text-muted">Additional</h6>

        <ul class="navbar-nav mb-md-3">
          <li class="nav-item">
            <a class="nav-link" href="/home">
              <i class="ni ni-tv-2"></i>
              <span class="nav-link-text">Main Website</span>
            </a>
          </li>
        </ul>
      </template>
    </side-bar>
    <div class="main-content">
      <div class="content">
        <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

        <div @click="$sidebar.displaySidebar(false)">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import { FadeTransition } from 'vue2-transitions'

import store from '@/store'
import router from '@/routes/router'
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  data() {
    return {
      loading: true,
      interval: null
    }
  },
  beforeMount() {
    this.loading = this.$loading.show()
  },
  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch('getToken').catch(async (_) => {
      await store.dispatch('logout')
      await router
        .push({ name: 'Log In', params: { continue: to.fullPath } })
        .catch(() => window.location.reload())
    })
    await store.dispatch('getUserInfo').catch(async (_) => {
      await store.dispatch('logout')
      await router
        .push({ name: 'Log In', params: { continue: to.fullPath } })
        .catch((_) => {})
    })
    await store.dispatch('affiliates/getAffiliateInfo').catch((_) => {})
    next()
  },
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition
  },
  computed: {
    ...mapGetters('affiliates', ['isEnrolled', 'isTeam'])
  },
  title() {
    return 'Affiliate Dashboard | ChinesePod'
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win')
      if (isWindows) {
        initScrollbar('scrollbar-inner')
      }
    }
  },
  mounted() {
    this.initScrollbar()
    this.loading.hide()
  }
}
</script>
<style lang="scss">
.content {
  min-height: calc(100vh - 80px);
}
.banner {
  z-index: 10000;
}
</style>
